export default {
  name: 're-blank-component',
}
